<div class="doc-upload-actions" *ngIf="!showCapture && showBackButton">
    <button mat-button class="secondary" (click)="return()">Back To Jacket</button>
</div>

<div class="upload-card" [ngClass]="{ hidden: !showBegin }">
    <mat-card>
        <div class="upload-card-body">
            <h2>License Back</h2>
            <p>Place ID face-down on a flat surface. Align the ID with the on screen frame.</p>
            <p>Once the barcode is found a green box will appear around it, and the scan will complete.</p>
            <div class="upload-card-actions pdf-column">
                <button class="mobile-view-btn" mat-button type="button" (click)="startCapture()">Begin Scanning</button>
            </div>
        </div>
    </mat-card>
</div>

<div class="upload-card" [ngClass]="{ hidden: !showFallback }">
    <mat-card>
        <div class="upload-card-body">
            <h2>License Back</h2>
            <p>
                We were unable to detect a barcode by scanning. Click Take Photo to use your device's camera to take a photo of the back of your license. You
                must ensure the image is sharp and on a contrasting background without glare.
            </p>
            <div class="upload-card-actions pdf-column">
                <button class="mobile-view-btn" mat-button type="button" (click)="startFallbackCapture()">Take Photo</button>
            </div>
            <input
                #fallbackInput
                type="file"
                accept="image/*"
                style="display: none"
                capture="environment"
                (change)="onFallbackCapture($event.target['files'][0])"
            />
        </div>
    </mat-card>
</div>

<div [ngClass]="{ hidden: !showCapture }" class="idn-component-container">
    <div class="dynamsoft-scan-container">
        <div class="capture-tip-container" *ngIf="currentTip" [ngClass]="{ 'document-accepted': barcodeFound }">
            <div class="tip-title">{{ currentTip.title }}</div>
            <div class="tip-subtitle" *ngIf="currentTip.subtitle">{{ currentTip.subtitle }}</div>
        </div>
        <div class="id-outline-container">
            <div class="id-outline" #idOutline [ngClass]="{ good: barcodeFound }">
                <div class="dce-scanarea" *ngIf="!barcodeFound">
                    <div
                        class="dce-scanlight"
                        style="
                            position: relative;
                            width: 100%;
                            height: 3%;
                            border-radius: 50%;
                            box-shadow: 0px 0px 2vw 1px #00e5ff;
                            background: #fff;
                            animation: 3s infinite dce-scanlight;
                            user-select: none;
                        "
                    ></div>
                </div>
            </div>
        </div>

        <div class="dce-video-container" #videoContainer></div>

        <div class="scan-navigation">
            <span (click)="cancelCapture()">
                <mat-icon>arrow_back</mat-icon>
            </span>
        </div>
        <style>
            @keyframes dce-rotate {
                from {
                    transform: rotate(0turn);
                }
                to {
                    transform: rotate(1turn);
                }
            }
            @keyframes dce-scanlight {
                from {
                    top: 0;
                }
                to {
                    top: 97%;
                }
            }
        </style>
    </div>
</div>

<div [ngClass]="{ hidden: !showPreview }" class="single-upload-preview-wrapper">
    <div class="upload-actions">
        <button mat-button type="button" class="primary" (click)="continue()">Continue</button>
        <button class="secondary" mat-button type="button" (click)="recapture()">Retake</button>
    </div>
    <div class="single-upload-preview-image-wrapper">
        <canvas #uploadPreview id="barcodeUploadPreview"> </canvas>
    </div>
</div>
